import { FC } from 'react';
import { buildAvatarImageSource } from '../../../../utils/buildAvatarImageSource';
import { Box } from '../../../layout/Box';
import { DataTestId } from '../../../layout/DataTestIdWrapper';
import { Avatar } from '../../../media/Avatar';
import { Typography } from '../../../typography/Typography';
import { InfoColumn } from '../../styles';
import { CollectionHeaderViewProps } from '../../types';
import { getStatus } from '../../utils/getStatus';

export const CollectionHeaderView: FC<CollectionHeaderViewProps> = ({ collectionModel }) => {
    const { author, defaultCollection, modifiable, displayName } = collectionModel;

    if (!author) {
        return null;
    }

    if (modifiable) {
        return (
            <InfoColumn>
                <Typography
                    textAlign="center"
                    variant="body"
                    weight="bold"
                    dataTestId={DataTestId.COLLECTION_NAME}
                    width="100%"
                    overflow="hidden"
                    style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {displayName}
                </Typography>
                <Box alignSelf="center">{getStatus(collectionModel, 'caption')}</Box>
            </InfoColumn>
        );
    }

    return (
        <>
            {!modifiable && !defaultCollection && author ? (
                <Avatar
                    src={buildAvatarImageSource(author.avatarUrl)}
                    title={author.displayName}
                    mr={1}
                    size={32}
                    minWidth={32}
                    height={32}
                />
            ) : null}
            <InfoColumn>
                {author ? (
                    <Typography
                        variant="caption"
                        width="100%"
                        overflow="hidden"
                        style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                        {author.displayName}
                    </Typography>
                ) : null}
                <Typography
                    variant="body"
                    weight="bold"
                    dataTestId={DataTestId.COLLECTION_NAME}
                    width="100%"
                    overflow="hidden"
                    style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {displayName}
                </Typography>
            </InfoColumn>
        </>
    );
};
